module.exports = __webpack_public_path__ + "img/astronaut.6e555a1f.svg";